import './pavilion/style';
import FormStructure from './pavilion/form_structure';

export default FormStructure;